import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class HardBreakHandler implements NodeHandler {
  readonly type = 'hardBreak';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    _childContent: string,
    _ctx: RenderContext
  ): string {
    return '\n';
  }
}

export class HorizontalRuleHandler implements NodeHandler {
  readonly type = 'horizontalRule';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    _childContent: string,
    _ctx: RenderContext
  ): string {
    return '---\n\n';
  }
}
